/*==========================================================
HOMEPAGE RESPONSIVE SCRIPTS
==========================================================*/

$(function() {
    if ($('#uber').hasClass('homepage')) {
        //News and Events Feed
        if ($().matchHeight) {
            $('.matchHeight').matchHeight();
        }
    }
});

function adjustSocialTabPos() {
    var tabs = $('.SMLink'),
        tabsW = 0;

    if (tabs.length) {
        tabs.each(function () {
            tabsW += $(this).outerWidth();
        });

        var initLeft = ($('#SMWrapper').outerWidth() - tabsW) / 2;
        for (var i = 0; i < tabs.length; i++) {
            if ($(window).width() >= 768) {
                $(tabs[i]).css({
                    left: initLeft + 'px'
                });
            } else {
                $(tabs[i]).css({
                    left: ''
                });
            }

            initLeft = initLeft + $(tabs[i]).outerWidth();
        }
    }
}

$(window).on('load resize', function () {
    adjustSocialTabPos();
});